module.exports = __webpack_public_path__ + "img/maestro.2ae5f024.png";